import { ReactNode } from 'react'

import styled from 'styled-components'

import { Flex } from '@/atoms/layout'
import { InputSmallText } from '@/atoms/typography'

export const EllipsisText = styled(InputSmallText)<{ title: ReactNode }>`
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  color: ${({ theme }) => theme.colors.heading};
`

export const LabelWrapper = styled(Flex)`
  align-items: flex-end;
  min-height: 16px;
  height: auto;
`
